'use client';

import AllTextPage from '@/app/(with-metadata)/shared/text/AllTextPage';

export default function TextOnePage() {
  return <AllTextPage textNumber='text1' />;
}
